export class RestApiError extends Error {
  readonly status: number;
  readonly method: string;
  readonly url: string;

  constructor(message: string, status: number, method: string, url: string) {
    super(message);
    this.name = `RestApiError: [${method.toUpperCase()}] ${url}`;
    this.status = status;
    this.method = method;
    this.url = url;
  }

  static isRestApiError = (error: unknown): error is RestApiError => error instanceof RestApiError;
}
